<template>
  <div class="page-template" v-loading="loading">
<!--    <div class="page-title">{{ title }}</div>-->
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="生鲜商品销售" name="fresh">
        <search-form-template
          :searchOptions="freshSearchOptions"
          @searchSubmit="searchSubmit"
          :toolConfig="toolConfig"
        ></search-form-template>
        <table-template ref="fresh"
                        :tableOptions="freshTable">
        </table-template>
      </el-tab-pane>
      <el-tab-pane label="鲜榨商品销售" name="press">
        <search-form-template
          :searchOptions="pressSearchOptions"
          @searchSubmit="searchSubmit"
          :toolConfig="toolConfig"
        ></search-form-template>
        <table-template ref="press"
                        :tableOptions="pressTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="日清商品销售" name="goods">
        <search-form-template
          :searchOptions="goodsSearchOptions"
          @searchSubmit="searchSubmit"
          :toolConfig="toolConfig"
        ></search-form-template>
        <table-template ref="goods"
                        :tableOptions="goodsTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="按个商品销售" name="individual">
        <search-form-template
          :searchOptions="individualSearchOptions"
          @searchSubmit="searchSubmit"
          :toolConfig="toolConfig"
        ></search-form-template>
        <table-template ref="individual"
                        :tableOptions="individualTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="混售商品销售" name="mix">
        <search-form-template
          :searchOptions="mixSearchOptions"
          @searchSubmit="searchSubmit"
          :toolConfig="toolConfig"
        ></search-form-template>
        <table-template ref="mix"
                        :tableOptions="mixTable"></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import searchFormTemplate from '@/components/template/searchFormTemplate';
  import tableTemplate from '@/components/template/tableTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    name: 'RoleManager',
    components: {
      tableTemplate,
      searchFormTemplate,
    },
    data() {
      return {
        activeTab: 'fresh',
        loading: false,
        treeConfig: {
          id: 'menuTree',
          showCheckbox: true,
          data: [],
          nodeKey: 'id',
          defaultProps: {
            children: 'children',
            label: 'name'
          },
          request: {
            api: api.system.rolePrivilege,
            param: {roleId: ''}
          }
        },

        // 更多功能
        toolConfig: [
          {
            label: '打印',
            code: 'print'
          },
          {
            label: '导出',
            code: 'export'
          }
        ],

        // 生鲜
        freshSearchOptions: {
          simple: [{
            label: '',
            type: 'input',
            prop: 'cashierSttName',
            isFuzzy: true,
            placeholder: '门店名称/ 姓名'
          },],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              span: 12,
              change: this.getFreshCashierChange,
              url: api.system.seStore
            },
            {
              label: '收银员',
              type: 'select',
              prop: 'cashierId',
              data: [],
              span: 12,
              // url: api.system.account,
              // param:{type:40}
            },
            {
              label: '方式',
              prop: 'zeroType',
              type: 'radio',
              span: 12,
              data: [{label: '包含抹零金额', value: 20}],
            },
          ]
        },
        // 鲜榨
        pressSearchOptions: {
          simple: [{
            label: '',
            type: 'input',
            prop: 'cashierReltName',
            isFuzzy: true,
            placeholder: '收银员/收银员编码'
          },],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              span: 12,
              data: [],
              change: this.getPressCashierChange,
              url: api.store.store,
            },
            {
              label: '收银员',
              type: 'select',
              prop: 'cashierId',
              data: [],
              span: 12,
              // url: api.system.account,
            },
            {
              label: '方式',
              prop: 'zeroType',
              type: 'radio',
              span: 12,
              data: [{label: '包含抹零金额', value: 20}],
            },
          ]
        },
        // 商品
        goodsSearchOptions: {
          simple: [{
            label: '',
            type: 'input',
            prop: 'customPayName',
            isFuzzy: true,
            placeholder: '收银员/收银员编码'
          },],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              span: 12,
              change: this.getGoodsCashierChange,
              url: api.system.seStore
            },
            {
              label: '收银员',
              type: 'select',
              prop: 'cashierId',
              data: [],
              span: 12,
              // url: api.system.account,
            },
            {
              label: '支付方式',
              type: 'select',
              prop: 'otherPayId',
              span: 12,
              data: this.$utils.getCacheStatus('soBillOrder.payType')
            },
            {
              label: '方式',
              prop: 'zeroType',
              type: 'radio',
              span: 12,
              data: [{label: '包含抹零金额', value: 20}],
            },
          ]
        },
        // 按个
        individualSearchOptions: {
          simple: [{
            label: '',
            type: 'input',
            prop: 'cashierDateName',
            isFuzzy: true,
            placeholder: '门店名称/收银员'
          },],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              span: 12,
              change: this.getIndividualCashierChange,
              url: api.system.seStore
            },
            {
              label: '收银员',
              type: 'select',
              prop: 'cashierId',
              data: [],
              span: 12,
              // url: api.system.account,
            },
            {
              label: '方式',
              prop: 'zeroType',
              type: 'radio',
              span: 12,
              data: [{label: '包含抹零金额', value: 20}],
            },
          ]
        },
        // 混售
        mixSearchOptions: {
          simple: [{
            label: '',
            type: 'input',
            prop: 'storeName',
            isFuzzy: true,
            placeholder: '门店名称'
          },],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              span: 12,
              url: api.system.seStore
            },
            {
              label: '方式',
              prop: 'zeroType',
              type: 'radio',
              span: 12,
              data: [{label: '包含抹零金额', value: 20}],
            },
          ]
        },

        // 生鲜
        freshTable: {
          indexShow: true,//是否显示索引
          param: {zeroType: 10}, // 不包含抹零
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店名称',
              prop: 'storeName',
              width: '180',
              align: 'center'
            },
            {
              label: '门店编码',
              prop: 'storeCode',
              width: '150',
              align: 'center',
            },
            {
              label: '收银员编码',
              prop: 'cashierCode',
              width: '150',
              align: 'center'
            },
            {
              label: '收银员名称',
              prop: 'cashierName',
              width: '150',
              align: 'center'
            },
            {
              label: '现金',
              prop: 'cashierMoney',
              width: '100',
              align: 'center',
            },
            {
              label: '店播',
              prop: 'dbyMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '银行卡',
              prop: 'bankCardMoney',
              width: '100',
              align: 'center',
            },
            {
              label: '微信',
              prop: 'weChatMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '支付宝',
              prop: 'aliMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '会员',
              prop: 'vipMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '小程序',
              prop: 'programMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '其他支付',
              prop: 'otherMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '组合支付',
              prop: 'combinationMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '合计(不含找零)',
              prop: 'totalMoney',
              width: '150',
              align: 'center'
            },
          ],
          url: api.retail.cashierDayStatement
        },
        // 鲜榨
        pressTable: {
          indexShow: true,//是否显示索引
          param: {zeroType: 10}, // 不包含抹零
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店名称',
              prop: 'storeName',
              width: '180',
              align: 'center'
            },
            {
              label: '门店编码',
              prop: 'storeCode',
              width: '150',
              align: 'center'
            },
            {
              label: '收银员编码',
              prop: 'cashierCode',
              width: '150',
              align: 'center'
            },
            {
              label: '收银员名称',
              prop: 'cashierName',
              width: '150',
              align: 'center'
            },
            {
              label: '交易方式',
              prop: 'orderType',
              width: '150',
              align: 'center',
              enumData: this.$utils.getCacheStatus('soBillOrder.orderType')
            },
            {
              label: '金额',
              prop: 'amountReceived',
              width: '150',
              align: 'center'
            }
          ],
          url: api.retail.cashierReconciliation
        },
        // 商品
        goodsTable: {
          param: {zeroType: 10}, // 不包含抹零
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店名称',
              prop: 'storeName',
              width: '180',
              align: 'center'
            },
            {
              label: '门店编码',
              prop: 'storeCode',
              width: '150',
              align: 'center'
            },
            {
              label: '收银员编码',
              prop: 'cashierCode',
              width: '150',
              align: 'center'
            },
            {
              label: '收银员名称',
              prop: 'cashierName',
              width: '150',
              align: 'center'
            },
            {
              label: '销售日期',
              prop: 'dayDate',
              width: '150',
              align: 'center'
            },
            {
              label: '支付方式',
              prop: 'payModeName',
              width: '150',
              align: 'center',
            },
            {
              label: '交易方式',
              prop: 'orderType',
              width: '150',
              align: 'center',
              enumData: this.$utils.getCacheStatus('soBillOrder.orderType')
            },
            {
              label: '金额',
              prop: 'amountReceived',
              width: '150',
              align: 'center'
            }
          ],
          url: api.retail.customPay
        },
        // 按个
        individualTable: {
          indexShow: true,//是否显示索引
          param: {zeroType: 10}, // 不包含抹零
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店名称',
              prop: 'storeName',
              width: '180',
              align: 'center'
            },
            {
              label: '门店编码',
              prop: 'storeCode',
              width: '150',
              align: 'center',
            },
            {
              label: '收银员编码',
              prop: 'cashierCode',
              width: '150',
              align: 'center'
            },
            {
              label: '收银员名称',
              prop: 'cashierName',
              width: '150',
              align: 'center'
            },
            {
              label: '销售日期',
              prop: 'dayDate',
              width: '150',
              align: 'center'
            },
            {
              label: '现金',
              prop: 'cashierMoney',
              width: '100',
              align: 'center',
            },
            {
              label: '店播',
              prop: 'dbyMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '银行卡',
              prop: 'bankCardMoney',
              width: '100',
              align: 'center',
            },
            {
              label: '微信',
              prop: 'weChatMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '支付宝',
              prop: 'aliMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '会员',
              prop: 'vipMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '小程序',
              prop: 'programMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '其他支付',
              prop: 'otherMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '组合支付',
              prop: 'combinationMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '合计(不含找零)',
              prop: 'totalMoney',
              width: '150',
              align: 'center'
            },
          ],
          url: api.retail.cashierDateStatement
        },
        // 混售
        mixTable: {
          param: {zeroType: 10}, // 不包含抹零
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店名称',
              prop: 'storeName',
              width: '150',
              align: 'center'
            },
            {
              label: '门店编码',
              prop: 'storeCode',
              width: '150',
              align: 'center',
            },
            {
              label: '销售日期',
              prop: 'dayDate',
              width: '150',
              align: 'center',
            },
            {
              label: '现金',
              prop: 'cashierMoney',
              width: '100',
              align: 'center',
            },
            {
              label: '店播',
              prop: 'dbyMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '银行卡',
              prop: 'bankCardMoney',
              width: '100',
              align: 'center',
            },
            {
              label: '微信',
              prop: 'weChatMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '支付宝',
              prop: 'aliMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '会员',
              prop: 'vipMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '小程序',
              prop: 'programMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '其他支付',
              prop: 'otherMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '组合支付',
              prop: 'combinationMoney',
              width: '100',
              align: 'center'
            },
            {
              label: '合计(不含找零)',
              prop: 'totalMoney',
              width: '150',
              align: 'center'
            },
          ],
          url: api.retail.storeCashier
        },
      };
    },
    created() {
      this.title = document.title;
      this.setStore(this.freshSearchOptions.complex);
      this.setStore(this.pressSearchOptions.complex);
      this.setStore(this.goodsSearchOptions.complex);
      this.setStore(this.mixSearchOptions.complex);
      this.setStore(this.individualSearchOptions.complex);
      this.getCashier();
    },
    // beforeMount(){
    //   this.setStore(this.individualSearchOptions.complex);
    //   this.setSupplier(this.individualSearchOptions.complex);
    // },
    // beforeUpdate() {
    //   this.setStore(this.goodsSearchOptions.complex);
    //   this.setSupplier(this.goodsSearchOptions.complex);
    // },
    methods: {
      searchSubmit(param) {
        this.$refs[this.activeTab].searchParam = param;
        this.$refs[this.activeTab].operationSuccess();
      },
      tabChange() {
        this.$refs[this.activeTab].operationSuccess();
      },
      getCashier() {
        let userInfo = this.$utils.getSysUser();
        if (userInfo.storeId) {
          this.$axios.fetchPost(api.system.type + '/list', {type: 40}).then(data => {
            if (data.code === 200) {
              this.freshSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
              this.pressSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
              this.goodsSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
              this.individualSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
            }
          })
        }
      },
      getFreshCashierChange(form) {
        form.cashierId = '';
        this.$axios.fetchPost(api.system.type + '/list', {storeId: form.storeId, type: 40}).then(data => {
          if (data.code === 200) {
            this.freshSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          }
        })
      },
      getPressCashierChange(form) {
        form.cashierId = '';
        this.$axios.fetchPost(api.system.type + '/list', {storeId: form.storeId, type: 40}).then(data => {
          if (data.code === 200) {
            this.pressSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          }
        })
      },
      getGoodsCashierChange(form) {
        form.cashierId = '';
        this.$axios.fetchPost(api.system.type + '/list', {storeId: form.storeId, type: 40}).then(data => {
          if (data.code === 200) {
            this.goodsSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          }
        })
      },
      getIndividualCashierChange(form) {
        form.cashierId = '';
        this.$axios.fetchPost(api.system.type + '/list', {storeId: form.storeId, type: 40}).then(data => {
          if (data.code === 200) {
            this.individualSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          }
        })
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/weigh/query/Sell.vue